<template>
  <div :id=id class="person">
    <img v-bind:src="imgUrl"  class="avatar" alt="avatar"/>
    <h2>{{ name }}</h2>
    <h3>{{ title }}</h3>
    <div class="hr"></div>

    <p>{{ desc }}</p>
    <div class="more">Read more</div>
    <a v-bind:href="linkedin">
      <div class="linkedin">
        <linkedin-icon-2 class="svg"></linkedin-icon-2>
        <div>Connect through LinkedIn</div>
      </div>
    </a>


  </div>
</template>

<script>
  export default {
    name: 'person',
    props: {
      id: String,
      imgUrl: String,
      name: String,
      title: String,
      desc: String,
      linkedin: String
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/scss/_variables";

  .person {
    color: $dark-grey;
    text-align: left;
    margin: 60px $margin-left;
    font-family: $title-font;
    box-sizing: border-box;

    @media screen and (min-width: $tablet-min) and (max-width: $tablet-max) {
      margin: 100px 25%;
    }

    @media screen and (min-width: $screen-min) and (max-width: $screen-max) {
      width: 50%;
      margin: 50px 0 50px 0;
      padding: 0 5%;
      position: relative;
    }

    @media screen and (min-width: $screen-L-min) {
      width: 33%;
      margin: 50px 0 50px 0;
      padding: 0 5%;
      position: relative;
      text-align: center;
    }

    img {
      width: 120px;
      height: 120px;
      border-radius: 200px;

      @media screen and (min-width: $screen-min) {
        width: 150px;
        height: 150px;
        margin-left: auto;
      }
    }

    h2 {
      font-size: 21px;
      font-weight: 600;
      text-align: left;
      margin: 0;
      margin-top: 20px;

    }

    h3 {
      color: $grey;
      font-size: 16px;
      font-weight: 600;
      text-align: left;
      margin: 0;
      margin-top: 10px;
    }

    .hr {
      height: 2px;
      background-color: $ligher-grey;
      width: 100%;
      margin: 20px 0;
    }

    p {
      font-size: 16px;
      line-height: 1.6em;
      text-align: left;
    }

    .more {
      display: none;

      @media screen and (min-width: $screen-min) and (max-width: $screen-max) {
        display: none;
        font-weight: 600;
        font-size: 14px;
        color: $light-blue;
        text-align: left;
      }
    }

    .linkedin {

      overflow: hidden;
      border: 1px solid $blue;
      width: 200px;
      height: 50px;
      margin: auto;
      margin-top: 35px;
      border-radius: 25px;
      cursor: pointer;
      text-align: center;

      svg {
        float: left;
        width: 25px;
        height: 25px;
        margin: 12.5px 0 12.5px 12.5px;
        background-color: $grey;
        fill: white;
        border-radius:20px;
      }

      div {
        color: $dark-grey;
        font-size: 11px;
        float: left;
        width: 150px;
        height: 50px;
        line-height: 50px;
      }

    }
  }
</style>
